import { render, staticRenderFns } from "./GroupedChartCard.vue?vue&type=template&id=25c5986c&"
import script from "./GroupedChartCard.vue?vue&type=script&lang=js&"
export * from "./GroupedChartCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports